export class ProductLineImageDto {
  id?: string;
  image?: string;
  size: string;
  type: string;
  url: string;

  constructor(d?: ProductLineImageDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);
  }
}
